
let viewer;
let products;
let productIds;
let materialNames;
let optionNames;
let optionValues;

const component_order = {
  "wood finish": 0,
  "metal finish": 1,
  "metal finish 2": 2,
  "column": 3,
  "column finish": 4,
  "fabric": 5
};

function getFileNameFromUrl(url) {  
    let urlObj = new URL(url);
    
    let pathname = urlObj.pathname;
    
    let imageName = pathname.split('/').pop();
    
    imageName = imageName.split('?')[0]; 
    imageName = imageName.split('#')[0];
    
    return imageName;
}

function sortComponentOrder(comp1, comp2) {
  let sort1 = 999;
  let comp1_name = comp1.name.toLowerCase();
  
  if (component_order.hasOwnProperty(comp1_name)) {
    sort1 = component_order[comp1_name];
  }

  let sort2 = 999;
  let comp2_name = comp2.name.toLowerCase();

  if (component_order.hasOwnProperty(comp2_name)) {
    sort2 = component_order[comp2_name];
  }

  if (sort1 > sort2) {
    return 1;
  } else {
    return -1;
  }
}

function takeScreenShot() {
  var productId = $('input[name="product-id"]').val();
  
  setTimeout(function() { 
    viewer.takeScreenShotBase64().then((result) => {
      console.log(result);
      
      if(result) {
        localStorage.setItem("cart_img_base64_" + productId, result);
      }
    });
  }, 1600);
}

function getOpitons(components) {
  let options = [];

  for (var i = 0; i < components.length; i++) {
     const component = components[i];

    var materials = [];

    let materials_data = component["materials"];

    for (var j = 0; j < materials_data.length; j++) {
      const material_data = materials_data[j];

      if ((material_data.name != "Default") && (typeof material_data.name !== "undefined") && (material_data.thumbnail != "")) {
        console.log(material_data);
        
        let imageFile = getFileNameFromUrl(material_data.thumbnail);
        let zoomIn = "https://img.chromcrafthome.com/" + imageFile;
        
        const material = {
          name: material_data.name,
          materialId: material_data.id,
          thumbnail: material_data.thumbnail + '?x-oss-process=image/resize,m_fill,w_64',
          zoomin: zoomIn
        };

        materials.push(material);
      }
    }

    materials.sort((a, b) => {
    	const aNumber = Number(a.name);
    	const bNumber = Number(b.name);

    	if (aNumber > bNumber) {
            return 1;
        } else if (aNumber < bNumber) {
            return -1;
        } else {
            return 0;
        }
    });
    
    const option = {
      name: component.name,
      materials: materials,
      componentIdStr: component.component_ids.join(",")
    };

    options.push(option);
  }

  options.sort(sortComponentOrder);

  return options;
}

function buildPanel(options) {
  let html = "";
  
  html += "<div class='cohoom-panel-content'>";

  options.forEach(function (option) {
    const materials = option.materials;

    html += "<div class='cohoom-option'>";
    html += "<div class='cohoom-option-name'><span>" + option.name + "</span><i class='fa-solid fa-circle-check'></i></div>";

    html += "<div class='cohoom-option-content'>";

    materials.forEach(function (material) {
      if (!material.name.includes("默认")) {
        html += "<div class='cohoom-block' data-material-zoomin='" + material.zoomin + "' data-option-name='" + option.name + "' data-component-id-str='" + option.componentIdStr + "' data-material-id='" + material.materialId + "'>";
        html += "<img class='cohoom-material-thumbnail' src='" + material.thumbnail + "'/>";
        html += "<div class='cohoom-material-name'>" + material.name + "</div>";
        html += "</div>";
      }
    });

    html += "</div>";
    html += "</div>";
  });

  html += "</div>";

  html += "<div class='cohoom-panel-clear' onclick='hidePanel()'></div>";

  const screenWidth = $(window).width();
  $("#cohoom-panel").append(html);
}

function buildMaterialNames(components) {
  let materialNames = [];

  for (var i = 0; i < components.length; i++) {
    let materials = components[i]["materials"];

    for (var j = 0; j < materials.length; j++) {
      const material = materials[j];
      materialNames[material.id] = material.name;
    }
  }

  return materialNames;
}

function buildOptionNames(options) {
  let optionNames = {};

  options.forEach(function (option) {
  });

  return optionNames;
}

function buildOptionValues(options) {
  let optionValues = {};

  options.forEach(function (option) {
    optionValues[option.name] = null
  });

  return optionValues;
}

function generateOptionDescription() {
  let description = "";

  const optionNames = Object.keys(optionValues);

  for (var i = 0; i < optionNames.length; i++) {
    const optionName = optionNames[i];
    const value = optionValues[optionName];

    description += optionName + ": " + materialNames[value]

    if (i < (optionNames.length - 1)) {
      description += ", ";
    }
  }

  return description;
}

function validateAddCart() {
  let validated = true;

  const keys = Object.keys(optionValues);

  for (var i = 0; i < keys.length; i++) {
    const key = keys[i];

    if (optionValues[key] == null) {
      validated = false;
      break;
    }
  }

  if (validated) {
    $('.cart-btn-cover').remove();
    $('button[name="add"]').prop('disabled', false);
    $('#show-sticky-product').prop('disabled', false);
  }
}

function loadCohoomCombineView(modelId) {
  let variantId = window.location.search.split('variant=')[1]
  viewer = new koolViewer.ViewerUISDK({
    mount: document.getElementById("cohoom-model"),
    apiSource: 'prod',
    kpxGroupId: modelId,
    autoRotate: false,
    useCoohomAPI: false,
    useCoohomCDN: true,
    enablePanel: false,
    enableOperationPanel: false,
    textureSize: 512,
    textureQuality: 50,
    lengthUnit: 'in',
    showRuler: true,    
    async afterDidMount() {      
      products = [];

      const productsData = viewer.getGroupProductInfo();

      productIds = [];

      $.each(productsData, function (productId, productData) {
        productIds.push(productId);
      });

      for (productId of productIds) {
        let componentIds = [];

        components = await viewer.getMaterialComponentInGroup(productId);

        for (component of components) {
          componentIds.push(component.id);
        }

        let product = {
          productId: productId,
          components: components,
          componentIds: componentIds
        };

        products.push(product);
      }

      var combined_component_objects = [];

      products.forEach(function (product) {
        product.components.forEach(function (component) {
          const key = component.name.toLowerCase();

          if (typeof combined_component_objects[key] === 'undefined') {
            combined_component_objects[key] = {
              name: component.name,
              materials: component.materials,
              'component_ids': []
            };
          }

          combined_component_objects[key].component_ids.push(component.id);
        });
      });

      setTimeout(() => {
        let components = [];
        //let localMatrixattr = $('.cohoom-wrap').attr('coohom-localmatrix').split(','));
        //localMatrixattr && viewer.modelViewer.camera.setMatrix(localMatrixattr);
        viewer.setAutoRotate();
        Object.keys(combined_component_objects).forEach(key => {
          components.push(combined_component_objects[key]);
        });
        const options = getOpitons(components);

        buildPanel(options);

        materialNames = buildMaterialNames(components);
        optionNames = buildOptionNames(options);
        optionValues = buildOptionValues(options);

        $('.skeleton-content').remove();
        $('#cohoom-model-skeleton').remove();

        $('.cohoom-model-wrap').append('<img class="cohoom-usa" src="https://cdn.shopify.com/s/files/1/0808/3193/8871/files/usa-v2.png?v=1717629621">');
        $('.cohoom-model-wrap').append('<img class="cohoom-usa" src="https://cdn.shopify.com/s/files/1/0808/3193/8871/files/usa-v2.png?v=1717629621">');
      }, 1000);
    }
  });
}

function togglePanel() {
  let panel = $('#cohoom-panel-mobile');

  if (panel.hasClass('animate__fadeInLeft')) {
    panel.removeClass("animate__fadeInLeft");
    panel.addClass("animate__fadeOutLeft");
    panel.hide();
  } else {
    panel.removeClass("animate__fadeOutLeft");
    panel.addClass("animate__fadeInLeft");
    panel.show();
  }
}

function hidePanel() {
  let panel = $('#cohoom-panel-mobile');
  panel.removeClass("animate__fadeInLeft");
  panel.addClass("animate__fadeOutLeft");
  panel.hide();
}

async function processMaterialChanges(products, componentIdStr, materialId) {
  const componentIds = componentIdStr.split(",");

  for (product of products) {
    let productId = product.productId;

    for (componentId of componentIds) {
      if (product.componentIds.includes(componentId)) {
        await viewer.changeMaterialInGroup(productId, componentId, materialId).promise;
        $('#cohoom-model-skeleton').remove();
      } 
    }
  }
}

$(document).on('click', '.cohoom-block', function () {

  //add loading effect
  //html = '<div id="cohoom-model-skeleton">';
  //html += '<div class="skeleton-block"></div>';
  //html += '</div>';
  //$(".cohoom-model-wrap").append(html);
  
  //add material select effect
  $(this).closest('.cohoom-option').find('.fa-circle-check').css('color', '#033c5a');
  $(this).closest('.cohoom-option').find('.cohoom-material-thumbnail').removeClass('cohoom-material-thumbnail-selected');
  $(this).find('.cohoom-material-thumbnail').addClass('cohoom-material-thumbnail-selected')

  //get data
  const optionName = $(this).attr('data-option-name');
  const materialId = $(this).attr('data-material-id');
  const componentIdStr = $(this).attr('data-component-id-str');

  //change materials
  processMaterialChanges(products, componentIdStr, materialId);

  //write option data
  optionValues[optionName] = materialId;
  const optionDescription = generateOptionDescription();
  $('#material').val(optionDescription);
  
  //validate cart
  validateAddCart();

  //store current view
  takeScreenShot();
});

function handleBtnCoverClick() { 
  $('.cohoom-alert-wrap').remove();
  
  let alertMessage = 'Please select ';

  let notSelectedMaterials = [];
  
  Object.entries(optionValues).forEach(([key, value]) => {    
    if(value == null) {
  	  notSelectedMaterials.push(key);
  	}  	
  });
  
  alertMessage += notSelectedMaterials.join(", "); 
  alertMessage += ' in the material panel';

  let alertElement = '<div class="cohoom-alert-wrap animate__animated animate__fadeInDown animate__faster">';
  alertElement += '<div class="cohoom-alert-inner">' + alertMessage + '</div>';
  alertElement += '</div>';
  
  $('body').append(alertElement);

  setTimeout(function() {
    $('.cohoom-alert-wrap').removeClass('animate__fadeInDown');
    $('.cohoom-alert-wrap').addClass('animate__fadeOutUp');
  }, 4000);
}

$(document).ready(function () {
  // Check if input elements with name "Configuration" exist in the DOM
  var configInputs = $('input[name="Configuration"]');
  //console.log("hello");
  // Only add the click event listener if such inputs exist
  if (configInputs.length > 0) {
    configInputs.on('click', function(event) {
      handleVariantClick(event);
    });
  }
  $(document).on('mouseenter', '.cohoom-block', function() {
    if(window.innerWidth > 768) {
      const zoomin = $(this).attr('data-material-zoomin');

      $('#cohoom-material-zoomin-combine').remove(); 
      let zoomInImage = '<div id="cohoom-material-zoomin-combine" class="animate__animated animate__fadeIn" style="background-image: url(' + zoomin + ')"></div>';
      $('.cohoom-wrap').append(zoomInImage);
    } 
  });

  $(document).on('mouseleave', '.cohoom-block', function() {
    $('#cohoom-material-zoomin-combine').remove(); 
  });
  
  //add cover button
  if ($('.cohoom-wrap').attr('modeltype') != 'mod') {
    const cartButtonCover = $('<div class="cart-btn-cover" onclick="handleBtnCoverClick()"><span></span></div>');
    $('.product-form__buttons').append(cartButtonCover);
  
    let cartButtonCoverStick = $('<div class="cart-btn-cover" onclick="handleBtnCoverClick()"><span></span></div>');
    $('.sticky-actions').append(cartButtonCoverStick);
  
    //disable add button
    $('button[name="add"]').prop('disabled', true);
    $('#show-sticky-product').prop('disabled', true);
  }

});

function handleVariantClick(event) {
  var selectedElement = $(event.target);
  var selectedValue = selectedElement.val();
  var coohomVariantId = selectedElement.attr('coohom-variant-id');
  var oldlocalMatrix = viewer.modelViewer.camera.getLocalMatrix();
  console.log("Selected variant:", selectedValue);
  console.log("Coohom Variant ID:", coohomVariantId);
  //if (viewer.modelData.modelId != coohomVariantId) {
    viewer.changeKpxGroupModel(coohomVariantId);
    viewer.modelViewer.camera.setMatrix(oldlocalMatrix);
    viewer.setAutoRotate();
  //}
}

